import { useEffect, useRef } from "react";
import Styles from "./Styles/BookDetails.module.css";
import convertNumbersToPersian from "../../../Utils/convertNumbersToPersian";

const BookDetails = ({ icon, alt, title1, title2, detail, view }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    const text = container.querySelector("h4");

    const checkOverflow = () => {
      if (text.scrollWidth > container.clientWidth) {
        text.classList.add("expanded");
      } else {
        text.classList.remove("expanded");
      }
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);

    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, []);
  return (
    <div ref={containerRef} className={Styles.container}>
      <div className={Styles.iconContainer}>
        <img src={icon} alt={alt} />
      </div>
      <h2>{title1}</h2>
      <h2>{title2}</h2>
      <div className={Styles.separator}></div>
      <h4>
        {detail
          ? detail
          : view
          ? convertNumbersToPersian(view.toString())
          : convertNumbersToPersian("0")}
      </h4>
    </div>
  );
};

export default BookDetails;
